module.exports = __webpack_public_path__ + "img/face.0cadb40b.svg";